<template>
  <property-form
    :value="
      value || {
        name: '',
        phone: '',
        inn: '',
        ogrn: '',
        email: '',
        trial: '',
        balance: '',
        city: '',
        trial_end_time: '',
      }
    "
    :fields="fieldDefs"
    @input="doSave"
  >
  </property-form>
</template>

<script>
import PropertyForm from "@/components/PropertyForm";
import { mapGetters } from "vuex";
import { VSelect } from "vuetify/lib/components";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "CompanyForm",
  components: { PropertyForm },
  props: [],
  computed: {
    ...mapGetters("modals", ["modalFormComponent"]),
    value() {
      return this.modalFormComponent?.value;
    },
    fieldDefs() {
      return {
        name: {
          order: 1,
          label: "Наименование",
          visible: true,
          rules: this.nameRules,
        },
        phone: {
          order: 2,
          label: "Телефон",
          visible: true,
          rules: this.phoneRules,
        },
        email: {
          order: 3,
          label: "E-Mail",
          visible: true,
          rules: this.emailRules,
        },
        inn: { order: 4, label: "ИНН", visible: true },
        ogrn: { order: 5, label: "ОГРН", visible: true },
        trial: {
          order: 6,
          label: "Пробный период",
          component: VSelect,
          items: ["Да", "Нет"],
          visible: true,
          rules: this.trialRules,
        },
        trial_end_time: {
          order: 7,
          label: "Конец пробного периода",
          component: Datetime,
          visible: true,
          rules: this.trialTimeRules,
        },
        balance: {
          order: 8,
          label: "Баланс",
          visible: true,
        },
        city: {
          order: 9,
          label: "Город",
          visible: true,
          rules: this.cityRules,
        },
      };
    },
  },
  data() {
    return {
      nameRules: [(v) => !!v || "Обязательное поле"],
      phoneRules: [
        (v) =>
          !v ||
          /^\+\d{1} \(\d{3}\) \d{3} \d{2} \d{2}$/.test(v) ||
          "Пример: +7 (999) 111 22 33",
      ],
      emailRules: [
        (v) => (!!v && !v.includes(" ")) || "Обязательное поле без пробелов",
        (v) => /.+@.+\..+/.test(v) || "Пример: abc@de.fg",
      ],
      trialTimeRules: [(v) => !!v || "Обязательное поле"],
      cityRules: [(v) => !!v || "Обязательное поле"],
    };
  },
  methods: {
    doSave(value) {
      this.$emit("confirm", { ...value });
    },
  },
};
</script>

<style scoped></style>
